import { render, staticRenderFns } from "./product_material_list.vue?vue&type=template&id=418197d7&scoped=true"
import script from "./product_material_list.vue?vue&type=script&lang=js"
export * from "./product_material_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418197d7",
  null
  
)

export default component.exports